// Hardcoded webinar campaign config. A future Super Admin campaign manager
// should be able to override these (date/time, platform, presenter, CTA)
// without touching page markup.
export const WEBINAR_CONFIG = {
  campaignTitle: 'TradingView Alert to Broker Order with AlgoSys',
  campaignType: 'Webinar',
  campaignStatus: 'Active',
  platformNote: 'Joining link will be shared by email and WhatsApp',
  durationMinutes: 60,
  presenter: 'AlgoSys Team',
  recordingPolicy: 'No public recording/replay will be shared',
  // No confirmed date/time yet — when set, render it; until then, omit the date block entirely.
  nextSessionLabel: null,
};

export const DEMO_WHATSAPP_URL =
  'https://wa.me/919903862980?text=I%27d%20like%20to%20book%20a%201-on-1%20AlgoSys%20setup%20demo';
